import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Every active job the current user can see. */
export function useJobsList() {
  return useQuery({
    queryKey: queryKeys.jobs.list(),
    queryFn: ({ signal }) => jobApiClient.index(toCancelToken(signal)),
    staleTime: 30_000,
    meta: { errorContext: 'jobs list' },
  });
}
